import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

type EventName = 'enterprise_contact_sales' | 'enterprise_book_demo';

export const sendHubSpotEvent = async ({
  token,
  eventName,
  properties,
}: APIRequest<{
  eventName: EventName;
  properties?: Record<string, unknown>;
}>): APIResponsePromise<{ success: boolean }> => {
  return await _callBackend(
    '/hubspot/events',
    'POST',
    {
      eventName,
      properties,
    },
    token,
  );
};
